/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { AxiosInstance, AxiosResponse } from "axios";
import { CustomizeAlertRequest } from "../NotificationTypes";
interface AlertSubscriptionChannel {
  channelType: 'email';
  channelConfig: { email: string };
  enabled: boolean;
}

interface AlertSubscriptionPayload {
  alertTemplateId: string;
  serviceId: string;
  serviceType: string;
  notificationChannels?: AlertSubscriptionChannel[];
  enabled?: boolean;
}

export function fetchMySubscriptions(
  api: AxiosInstance,
  // params: URLSearchParams
): Promise<AxiosResponse> {
  return api.get(`/kontroledge/monitoring/alerts/subscriptions/my?includeAlertDetails=true`);
}

export function fetchAllAlertSubscriptions(
  api: AxiosInstance,
  subscriberType: "user" | "tenant",
  subscriberId: string,
  includeAlertDetails = true
) {
  const qs = new URLSearchParams({
    subscriberType,
    subscriberId,
    includeAlertDetails: String(includeAlertDetails),
  }).toString();

  return api.get(`/kontroledge/monitoring/alerts/subscriptions?${qs}`);
}
//------------------------------------------------------
/* For the dropdown alerts and Notifications History view*/
//------------------------------------------------------
//Get Alert Events
//Retrieve historical alert events 
export function fetchAlertsList(
  api: AxiosInstance,
): Promise<AxiosResponse> {
return api.get(`/kontroledge/monitoring/alert-events`)
}
//-------------
//Get Alert Events
//Retrieve historical alert events filtered by serviceId
export function fetchAlertsListByService(
  api: AxiosInstance,
  serviceId: string,
): Promise<AxiosResponse> {
  return api.get(
    '/kontroledge/monitoring/alert-events',
    { params: { resourceId: serviceId } }
  );
}


//------------------------------------------------------
//Get All Alert Subscriptions
//Used in Port Detail, Connection Detail Views
//Retrieve subscriptions for the detailed view in the services
export function fetchAlertsServiceId(
  api: AxiosInstance,
  type: string,
  serviceId: string,
  subscriberType: string,
  subscriberId: string
): Promise<AxiosResponse> {
  return api.get(
    `/kontroledge/monitoring/alerts/subscriptions`,
    {
      params: {
        serviceType:     type,
        serviceId:       serviceId,
        includeAlertDetails: true,
        subscriberType:  subscriberType,
        subscriberId:    subscriberId,
      },
    }
  );
}
//------------------------------------------------------
//Used in Notifications module Organizational and My Notirications
//Retrieves the customers list for the partnerId logged or selected
export function fetchCustomerSettings(
  api: AxiosInstance,
  tenantId: number,
): Promise<AxiosResponse> {
  return api.get(`/tenant/customers?tenantId=${tenantId}`, {
  })
}
//------------------------------------------------------
//Retrieves the customer and service name
//This 2 fields are required to send them as params for the alerts visualization ep in Organizational and MyNotifications
export function fetchAlertsHierarchically(
  api: AxiosInstance,
  tenantId: number
): Promise<AxiosResponse> {
  return api.get("/kontroledge/monitoring/alerts/subscriptions/hierarchy", {
    params: {
      tenantId,
    },
  });
}
//------------------------------------------------------
//Retrieves the customer and service name
//This 2 fields are required to send them as params for the alerts visualization ep in Organizational and MyNotifications
export function fetchCustomersServices(
  api: AxiosInstance,
  tenantId: number
): Promise<AxiosResponse> {
  return api.get("/tenant/customers-with-services", {
    params: {
      tenantId,
    },
  });
}
//------------------------------------------------------

//------------------------------------------------------
//Get Alert Events
//Retrieve historical alert events 
export function fetchAllAlertInstances(
  api: AxiosInstance,
  serviceType: string,
  serviceId: string
): Promise<AxiosResponse> {
  return api.get(`/kontroledge/monitoring/alerts/instances`, {
    params: {
      serviceType,
      serviceId,
      hasSubscriptions: true
    }
  });
}
//------------------------------------------------------
//Update Subscription's Enabled Status
//Disables the subscription 
export function updateSubscriptionEnabled(
  api: AxiosInstance,
  subscriptionId: string,
  enabled: boolean
) {
  return api.put(
    `/kontroledge/monitoring/alerts/subscriptions/${subscriptionId}`,
    { enabled }
  );
}


//------------Notification Channels--------------

/* Add Notification Channel to Alert Subscription */
// Adds a brand-new email channel to a subscription
export function addEmailChannel(
  api: AxiosInstance,
  subscriptionId: string,
  emails: string[]
) {
  return api.post(
    `/kontroledge/monitoring/alerts/subscriptions/${subscriptionId}/channels`,
    {
      channelType: "email",
      channelConfig: { emails },
    }
  );
}

/* Update Notification Channel */
// updates an existing channel’s email list
export function updateEmailChannel(
  api: AxiosInstance,
  subscriptionId: string,
  channelId: string,
  emails: string[]
) {
  return api.put(
    `/kontroledge/monitoring/alerts/subscriptions/${subscriptionId}/channels/${channelId}`,
    {
      channelConfig: { emails },
      enabled: true,
    }
  );
}

//------------Alerts--------------
/* Alert Access Control */
//Enable / Disable access to the notifications module for the customers in Customer settings
export function notificationModuleEnabled(
  api: AxiosInstance,
  tenantId: number,
  canAccessAlerts: boolean
) {
  return api.post(
    `kontroledge/monitoring/alerts/access-control`,
    { tenantId, canAccessAlerts }
  );
}


//------------Custom Alerts--------------
/* Get Custom Alerts */
//We get all the alerts that are customized
export function fetchCustomAlerts(
  api: AxiosInstance,
  subscriberType: string,
  subscriberId: string
) {
  return api.get<{
    data: Array<{
      id: string;
      originalAlertId: string;
      customParameters: { conditions?: any[]; interval?: string; severity?: string; tags?: string[] };
      isCustomized: boolean;
      conditions?: any[];
      interval?: string;
      severity?: string;
      tags?: Record<string,unknown>;
    }>;
  }>(
    `/kontroledge/monitoring/alerts/custom/${subscriberType}/${subscriberId}`
  );
}
/* Customize Alert */
//Create a copy of the alert with custom parameters
export function createAlertParameters(
  api: AxiosInstance,
  alertId: string,
  payload: CustomizeAlertRequest
) {
  return api.post(
    `/kontroledge/monitoring/alerts/${alertId}/customize`,
    payload
  );
}
/* Update Custom Alert Parameters */
//Updates the parameters of the customized alert
export function updateAlertParameters(
  api: AxiosInstance,
  customAlertId: string,
  payload: CustomizeAlertRequest
) {
  return api.put(
    `/kontroledge/monitoring/alerts/custom/${customAlertId}/parameters`,
    payload
  );
}


//------------Alert Templates--------------
/* Get All Alert Templates */
//We get all the templates to subscribe to the alert
export function fetchTemplatesList(
  api: AxiosInstance,
): Promise<AxiosResponse> {
return api.get(`/kontroledge/monitoring/alerts/templates`)
}

/* Create Custom Service Alert */
//Creates an alert with automatic subscription management (Enable template)
export function enableTemplate(
  api: AxiosInstance,
  payload: AlertSubscriptionPayload,
  tenantId?: number
) {
  const qs = tenantId != null ? `?tenantId=${tenantId}` : "";
  return api.post(
    `/kontroledge/monitoring/alerts/service-alert${qs}`,
    payload
  );
}

//------------------------------------------------------
//Bulk Subscribe to Organization
//Enables the organization configuration
export function enableOrganizationalConfig(
  api: AxiosInstance,
): Promise<AxiosResponse> {
  return api.post(
    `/kontroledge/monitoring/alerts/subscriptions/bulk-organizational`,
  );
}

//------------------------------------------------------
//Bulk Unsubscribe from Organizational Alerts
//Enables the organization configuration
export function disableOrganizationalConfig(
  api: AxiosInstance,
): Promise<AxiosResponse> {
  return api.delete(
   `/kontroledge/monitoring/alerts/subscriptions/bulk-organizational`,
  );
}